import { DataBean } from "../DataBean";

export class CommercialCampaign extends DataBean {


    public async getCommercialCampaignCatalog(year: any, month: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getCommercialCampaignCatalog_Number_Number_Number_Number", [year, month, page, recordsPerPage]);
    }

    public async deleteCommercialCampaign(idCommercialCampaign: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteCommercialCampaign_Number", [idCommercialCampaign]);
    }


}